import { AliasSearchDto, ClientResources } from '@app/api2/api';
import * as Yup from 'yup';

export const AliasSearchSchema: (t: ClientResources) => Yup.SchemaOf<AliasSearchDto> = (t) => Yup.object({
    discriminator: Yup.string().required(),
    operator: Yup.string().optional(),
    alias: Yup.string().required().label(t.metadata.aliasNameLabel || 'Alias'),
});
